import {api} from './requestGraphql'

const getApplications = async ({limit, page, orderBy, orderDirectionAsc, filters}) => {
    const search = filters.search ? `"${filters.search}"` : '""';
    const affiliateName = filters.affiliateName ? `"${filters.affiliateName}"` : '""';
    const offerName = filters.offerName ? `"${filters.offerName}"` : '""';
    const status = filters.status ? `"${filters.status}"` : '""';
    const email = filters.email ? `"${filters.email}"` : '""';
    const dba = filters.dba ? `"${filters.dba}"` : '""';
    const promotionMethods = filters.promotionMethods ? `"${filters.promotionMethods}"` : '""';
    const websites = filters.websites ? `"${filters.websites}"` : '""';
    const audienceMatch = filters.audienceMatch ? `"${filters.audienceMatch}"` : '""';
    const estimatedVolume = filters.estimatedVolume ? `"${filters.estimatedVolume}"` : '""';
    const comments = filters.comments ? `"${filters.comments}"` : '""';
    const dateAdded = filters.dateAdded ? `"${filters.dateAdded}"` : '""';

    const order = orderBy ? `"${orderBy}"` : '"name"';
    try {
        const res = await api.post(
            '', {
                query: `
                    {
                        getApplications(
                            pagination: {
                                page: ${page},
                                limit: ${limit}
                            },
                            sorting: {
                                orderBy: ${order},
                                orderDirectionAsc: ${orderDirectionAsc}
                            }, 
                            filters: {
                              search: ${search}
                              affiliateName: ${affiliateName}
                              offerName: ${offerName}
                              status: ${status}
                              email: ${email}
                              dba: ${dba}
                              promotionMethods: ${promotionMethods}
                              websites: ${websites}
                              audienceMatch: ${audienceMatch}
                              estimatedVolume: ${estimatedVolume}
                              comments: ${comments}
                              dateAdded: ${dateAdded}
                            }
                        ){
                            applications{
                              id  
                              affiliateName
                              offerName
                              status
                              email
                              dba
                              promotionMethods
                              websites
                              audienceMatch
                              estimatedVolume
                              comments
                              dateAdded
                            }
                            filters{
                              affiliateName{
                                key
                                value
                              }
                              offerName{
                                key
                                value
                              }
                              status{
                                key
                                value
                              }
                              email{
                                key
                                value
                              }
                              dba{
                                key
                                value
                              }
                              promotionMethods{
                                key
                                value
                              }
                              websites{
                                key
                                value
                              }
                              estimatedVolume{
                                key
                                value
                              }
                              comments{
                                key
                                value
                              }
                              dateAdded{
                                key
                                value
                              }
                             }
                        }
                    }
                `
            }
        );

        return res.data.data.getApplications
    } catch (e) {
        console.error(e)
    }
};

const massApplicationUpdate = async ({ids, status}) => {
    try {
        const res = await api.post(
            '', {
                query: `
                    mutation {
                        massApplicationUpdate(ids:[${ids}], status: "${status}")
                    }
                `
            }
        );

        return res.data.data.massApplicationUpdate
    } catch (e) {
        console.error(e)
    }
};

export default {
    getApplications,
    massApplicationUpdate
}